import { Component, OnInit, ChangeDetectorRef, Output, EventEmitter, OnDestroy, HostListener } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ApplicationInitService } from './services/application-init.service';
import { AppService } from './shared/services/app.service';
import { CommunicationService } from './services/communication.service';
import { navItems } from "./_nav";
import { BaseService } from './shared/services/base.service';
import { AlertsService } from './services/alerts.service';
import { AuthenticationService } from './shared/services/authentication.service';
import { StorageService } from './shared/services/storage.service';
import { ClassToggler } from './layout/coreui/shared/toggle-classes';
import { sidebarCssClasses } from './layout/coreui/shared';
import { Subscription, timer } from 'rxjs';
import { MessagingService } from './shared/services/messaging.service';
import { TranslateService } from './services/translate.service';
import { LoaderService } from './services/loader.service';
import { SmartModalService, ModalSize } from './services/smart-modal.service';
import { EulaComponent } from './components/eula/eula.component';
import { RolePermissionService } from './shared/services/role-permission.service';
import { UtilService } from './services/util.service';
import { AppAlertComponent } from './components/app-alert/app-alert.component';
import { BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { SearchAndSelect } from './components/form/models/serachselect.model';
import { SpeedTestComponent } from './components/speedtest/speedtest.component';
import { ScreenShortcutsComponent } from './components/screen-shortcuts/screen-shortcuts.component';
import { SelectProfileComponent } from './components/select-profile/select-profile.component';
import { PopupFormComponent } from './components/popupform/popupform.component';
import { DialogRef } from './components/dialog/dialog-ref';
import { SpeedService } from './services/speed.service';
import { CareTypeService } from './shared/services/care-type.service';
import { distinctUntilChanged, filter } from 'rxjs/operators';
import { PreferenceService } from './shared/services/preference.service';
import { ConsentCheckComponent } from './components/consent-check/consent-check.component';
import { ADService } from './services/ad.service';
import { ConvoxPatientMobileComponent } from './components/convox-patient-mobile/convox-patient-mobile.component';
//import { LoginMobileNoComponent } from '../account-management/components/login-mobile-no/login-mobile-no.component';
import { HtmlViewerComponent } from './components/viewer/html-viewer/html-viewer.component';
import * as CryptoJS from 'crypto-js';
import polyline from 'google-polyline';
import { AsideBarService } from './services/asideBar.service';
import { AccessibilityComponent } from './components/accessibility/accessibility.component';

declare var pwaPrompt: any;
declare var google: any;
declare var jQuery: any;
//declare var UserWay: any;
@Component({
    selector: 'app-base',
    //templateUrl: 'layout/kx/kx.layout.html',
    templateUrl: 'layout/coreui/coreui.layout.html',
    styleUrls: ['./base.component.scss'],
    providers: [ClassToggler],
    standalone: false
})
export class BaseComponent implements OnInit, OnDestroy {

  public headerJson: any = {};
  //breadcrumbs: Array<any>[];
  minimized = false;
  isTokenPopoverOpen: boolean = false;
  public navItems = [...navItems];
  // orginization dropdown
  public _currentData: any = {};
  payload: any;
  private subscriptions: Subscription = new Subscription();
  timeSub: any;
  public landingUrl: String = "";
  payloadCount: any;
  showNotification: boolean = false
  changeColor: any;
  scrollPage: number = 10;
  count: any;
  config: any = { headerComponent: {},showSuperApp:false };
  speedConfig: any = {};
  storeAllowed: boolean = false;
  selectedLanguage: any = "";
  totalCount: any;
  showInstallBtn: boolean = false;
  isAndroid: boolean = false;
  facilitySearchSelect: FacilitySearchSelectModel;
  componentClass: any;
  profile_path: any;
  currentResourecValue$: boolean = false;
  checkResourceDisbled$: boolean = false;
  finalFilterVal: string = "";
  @Output() onFilterChange: EventEmitter<any> = new EventEmitter();
  superApps: Array<any>[];
  isHelpDocumentAvailable: boolean = false;
  routerSubscription: Subscription;
  storeSearchedInput: string = '';
  // message: any;

  // orginization dropdown
  constructor(
    public router: Router,
    private applicationInitService: ApplicationInitService,
    public appService: AppService,
    private communicationService: CommunicationService,
    private activateRoute: ActivatedRoute,
    public baseService: BaseService,
    private alertService: AlertsService,
    public auth: AuthenticationService,
    private storageService: StorageService,
    private classToggler: ClassToggler,
    private messagingService: MessagingService,
    private loaderService: LoaderService,
    private translateService: TranslateService,
    private modalService: SmartModalService,
    private bsModalService: BsModalService,
    public roleService: RolePermissionService,
    private cdr: ChangeDetectorRef,
    public utilService: UtilService,
    private dialogRef: DialogRef,
    public speedService: SpeedService,
    private careService: CareTypeService,
    public preferenceService: PreferenceService,
    public rolePermissionService: RolePermissionService,
    public adService:ADService,
    private cdRef: ChangeDetectorRef,
    public asideBarService: AsideBarService
  ) {
    this.facilitySearchSelect = new FacilitySearchSelectModel();
    this.isAndroid = utilService.isAndroid();    
    if (activateRoute.snapshot.data != undefined && activateRoute.snapshot.data.application != undefined) {
      appService.setApplication(activateRoute.snapshot.data.application);
    }
    console.log("activateRoute.snapshot.data", activateRoute.snapshot.data);
    applicationInitService.init(appObj => {
      this.headerJson = appObj.headerJson;
      if (this.appService._appData.APPLICATION_AWARE) {
        this.landingUrl = (this.appService._currentSessionData.dashboardUrlFound != undefined) ? this.appService._currentSessionData.dashboardUrlFound : this.appService._appData.DEFAULT_APPLICATION + '/dashboard';
        this.appService._currentSessionData.sidebarJson = this.appService.getMenuList();
      } else {
        this.appService._currentSessionData.sidebarJson = JSON.parse(JSON.stringify(this.appService._appData.MENU_DEF));
        this.appService._currentSessionData.sidebarJson = applicationInitService.filterSidebar(this.appService._currentSessionData.sidebarJson);
      }
    });

    this.subscriptions.add(communicationService.changeEmitted$.subscribe(data => {
      // this.breadcrumbs = data.breadcrumbs;
      if (data.hideMenuIcon != undefined)
        this.appService._currentSessionData.hideMenuIcon = data.hideMenuIcon;
    }));

    this.subscriptions.add(communicationService.emitComponentClass$.subscribe(data => {
      this.componentClass = data;
    }));

    this.subscriptions.add(communicationService.sideBarEmitted$.subscribe(data => {
      if (data.sidebar != undefined) {
        if (!data.sidebar) {
          this.classToggler.removeClassesCustom(sidebarCssClasses);
        } else {
          this.classToggler.removeClassesCustom(sidebarCssClasses);
          const cssClass = `sidebar-lg-show`;
          this.classToggler.toggleClasses(cssClass, sidebarCssClasses);
        }

      }
    }));

    this.subscriptions.add(communicationService.storagevalueEmitted$.pipe(distinctUntilChanged((prev, curr) => prev === curr)).subscribe((value: any) => {
      this.baseService.getResourceDef(value, (res: any) => {
        this.currentResourecValue$ = ((res.config != undefined && res.config.care_type != undefined && res.config.care_type.header != undefined) ? res.config.care_type.header : false);
        this.checkResourceDisbled$ = ((res.config != undefined && res.config.care_type != undefined && res.config.care_type.disabled != undefined) ? res.config.care_type.disabled : false)
      })
    }));

    this.subscriptions.add(preferenceService.headerConfig$.subscribe(data => {
      this.isHeaderComponetsAllowed();
    }));
  }

  @HostListener('document:click', ['$event'])
  clickOutside(event: MouseEvent) {
    if (this.isTokenPopoverOpen) {
      const target = event.target as HTMLElement;
      if (!target.closest('.tokenKeyContainer') && !target.closest('.qms-token-button')) {
        this.isTokenPopoverOpen = false;
      }
    }
  }

  // Ctrl/Cmd+U opens the accessibility panel — preventDefault stops Chrome's
  // default "view page source" action from firing on the same combo.
  @HostListener('document:keydown', ['$event'])
  handleAccessibilityShortcut(event: KeyboardEvent) {
    if (!(event.ctrlKey || event.metaKey) || event.altKey || event.key.toLowerCase() !== 'u') {
      return;
    }
    // Ctrl+U is also CKEditor's native "Underline" — don't hijack it while
    // the user is typing in an input/textarea/contenteditable/rich-text field.
    const target = event.target as HTMLElement;
    if (target?.closest?.('input, textarea, select, [contenteditable]')) {
      return;
    }
    event.preventDefault();
    this.tooglAccessibility();
  }

  toggleTokenPopover(event: MouseEvent) {
    event.stopPropagation();
    this.isTokenPopoverOpen = !this.isTokenPopoverOpen;
  }

  keepTokenPopoverOpen(event: MouseEvent) {
    event.stopPropagation();
  }


  ngOnInit() {
    this.payload = [];
    // debugger
    this.superApps = this.appService._currentSessionData.superApps;
    this.config.showSuperApp = this.showSuperApp();
    if (this.appService.getUniversalConfig('profile_id'))
      this.getProfilePath()
    this.initData();
    if (this.appService._appData.ORG_AWARE) {
      if (this.landingUrl.split("").includes("?")) {
        // if (this.router.url == '/' + this.landingUrl) {
        this.getOrganization();
        // } else {
        // this._currentData.org = this.appService.getOrganization();
        // }
      } else {
        // if (this.router.url.split('?')[0] == '/' + this.landingUrl) {
        this.getOrganization();
        // } else {
        //   this._currentData.org = this.appService.getOrganization();
        // }
      }
    }
    this.isHeaderComponetsAllowed();
    if (this.appService._appData.MULTI_ROLE) {
      this.getRoles();
    }
    //Location set by default
    if (this.appService.isLocationAware()) {
      this.getLocation();
    }
    /**** THIS NEEDS TO BE REVIEWED, IT FIRES EVERY TIME */
    this.setLatLng();

    this.subscriptions.add(this.messagingService.colorOfBell().subscribe((res: any) => {
      console.log("res for notification is :: ", res)
      this.changeColor = res
    }));

    this.subscriptions.add(this.messagingService.getNotificationPayload$().subscribe((res: any) => {
      if (res && res.notification && res.notification.title && res.notification.title == "token-alert") {
        this.communicationService.setTokenValue(res);
      }
    }));
    if (this.checkSystemAdmin())
      this.getNotificationCount();
    this.checkStore();
    this.getLanguage();

    this.subscriptions.add(this.speedService.getConfig().subscribe(data => {
      console.log("SPEED", data)
      this.speedConfig.data = data;
      this.cdr.detectChanges();
    }));
    this.getAgeConfig();
    // this.getPrintEngineTemplate();
    this.baseService.getNotice((notice) => {
      this.config.noticeList = this.appService.getNotice();
      this.handleList(false);
      if (notice) {
        console.log("NOTICE LOADED");
        setTimeout(() => {
          if (this.config.noticeList.length > 0 && jQuery('.notice-container .message-container')[0].scrollWidth > jQuery('.notice-container .message-container').innerWidth()) {
            this.config.noticeList[0]["readMore"] = true;
          }
        })
      }
    })

    this.setDownloadOnly();

    if (!this.utilService.isMobile() && !this.checkKioskUser() && this._currentData.currentUser && this._currentData.currentUser['user_type'] == 'patient') {
      this.checkHelpDocumentAvailability();
    }
  }

  get isPatientHelpDocumentAvailable(): boolean {
    return !this.utilService.isMobile() && !this.checkKioskUser() && this._currentData.currentUser && this._currentData.currentUser['user_type'] == 'patient' && this.isHelpDocumentAvailable;
  }

  checkHelpDocumentAvailability() {
    this.loaderService.showSpinner();
    this.routerSubscription = this.baseService.get('GET_DOCUMENT_BY_URL', 'doc_url:' + this.router.url, 'help_doc', 'opsmgmt').subscribe((data: any) => {
      if (data.errCode == 0 && data.resource.length > 0) {
        this.isHelpDocumentAvailable = true;
      } else {
        this.isHelpDocumentAvailable = false;
      }
      this.config.helpdeskTicket = true;
      this.loaderService.hideSpinner();
    });
  }

  onLocationSearch(): void {
    const search = this.storeSearchedInput?.trim().toLowerCase();
    if (!search) {
      this._currentData.locationList = this.appService.getLocation() || [];
      return;
    }
    this._currentData.locationList = (this.appService.getLocation() || [])
      .filter((location: any) =>
        location.location_name?.toLowerCase().includes(search)
      );
  }

  initLocationList(): void {
    this.storeSearchedInput = '';
    this._currentData.locationList = this.appService.getLocation() || [];
  }

  toggleLocationDropdown(): void {
    this.config.showLocation = !this.config.showLocation;
    if (this.config.showLocation) {
      this.initLocationList();
    }
  }
  
  trackByLocationId(index: number, location: any): any {
    return location.location_id || index;
  }

  setDownloadOnly() {
    try {
      if (this.appService != undefined && this.appService._currentSessionData != undefined && this.appService._currentSessionData.view_only != undefined && this.appService._currentSessionData.view_only === true) {
        this.subscriptions.add(this.baseService.get("GET_CONFIG", "module_code:bulk-download,config_code:download_permission", "facility_config_mapping", "facility-management").subscribe(data => {
          if (data.errCode == 0 && data.resource.length > 0 && data.resource[0].config_value == 'false') {
            this.appService._currentSessionData['view_only_download'] = false;
          }
          else if (data.errCode == 0 && data.resource.length > 0 && data.resource[0].config_value == 'true') {
            this.appService._currentSessionData['view_only_download'] = true;
          }

        }));
      }
    } catch (error) { }

  }

  isHeaderComponetsAllowed() {
    this.config["headerComponent"] = {}
    var allHeaderList = this.preferenceService.getHeaderList();
    for (let index = 0; index < allHeaderList.length; index++) {
      let header = allHeaderList[index];
      this.config["headerComponent"][header.name] = this.preferenceService.isHeaderComponentAllowed(header.name);
    }
  }

  readFullNotice() {
    this.subscriptions.add(this.modalService.open(ScreenShortcutsComponent, {}, '', ModalSize.Md, 'center', true).subscribe(res => {
      if (res) {
        console.log('tnc modal closed');
      }
    }, err => {
      console.error('error occured in tnc modal', err);
    }));
    setTimeout(() => {
      jQuery('.kx-cstm-popup-title').children("h5").text("Message");
      jQuery('app-screen-shortcuts .screen-sh-container').html('<div class="notice-message">' + this.config.noticeList[0]["text"] + '</div>');
      //jQuery('app-screen-shortcuts').html(this.config.noticeList[0]["text"]);
      jQuery('app-screen-shortcuts').parent().parent().addClass(this.config.noticeList[0]['priority'] + "-msg")
    })
  }
  handleList(remove) {
    if (remove) {
      document.body.classList.remove("show-message");
      this.config.noticeList = [];
      this.appService.setNotice([]);
    } else {
      if (this.config.noticeList.length > 0) {
        document.body.classList.add("show-message")
      }
    }
  }

  // getPrintEngineTemplate() { // It's a temporary function, we should remove after new print templates avaiable live.
  //   if(this.appService._currentSessionData && this.appService._currentSessionData.print_engine){
  //     if(this.appService.printEngineTemplate == null || this.appService.printEngineTemplate.length == 0){
  //     this.baseService.get("GET_CONFIG_FOR_ACCOUNT", "module_code:printengine,config_code:print_engine_template", "facility_config_mapping", "facility-management").subscribe(data => {
  //       if (data.errCode == 0 && data.resource.length > 0) {
  //         if(data.resource[0].multivalue){
  //           let printTemplate = data.resource[0].multivalue;
  //           this.appService.printEngineTemplate = printTemplate;
  //         }
  //       }
  //     });
  //   }
  // }
  // }

  checkCareTypeDisabled() {
    return true
  }

  getAgeConfig() {
    if (localStorage.getItem("ageConfig") == null || localStorage.getItem("ageConfig") == undefined) {
      this.subscriptions.add(this.baseService.get("GET_CONFIG", "module_code:emr,config_code:age_years", "facility_config_mapping", "facility-management").subscribe(data => {
        if (data.errCode == 0 && data.resource.length > 0) {
          if (data.resource[0].config_value != undefined && data.resource[0].config_value != "") {
            if (data.resource[0].config_value == 0) {
              localStorage.setItem("ageConfig", "0");
            } else {
              localStorage.setItem("ageConfig", data.resource[0].config_value);
            }
          } else {
            localStorage.setItem("ageConfig", "0");
          }
        }
      }));
    }
  }

  changeVoiceEnable(event: any): void {
    let selectedVoice = event;
    this.preferenceService._saveCommonVoiceDetailsConfig('voice_search', selectedVoice, ()=>{
      window.location.reload();
    });
  }

  getLanguage() {
    this.translateService.getLanguage((data) => {
      if (data && this.appService != undefined && this.appService._currentSessionData != undefined && this.appService._currentSessionData.languageList != undefined && this.appService._currentSessionData.languageList) {
        let langList = this.appService._currentSessionData.languageList;
        this.selectedLanguage = langList.find(x => x.languageCode === data).languageName;
      }
    });
  }
  checkStore() {
    this.storeAllowed = this.appService._appData.APPLICATIONS_STORE.indexOf(this.appService.getApplication()) > -1 ? true : false;
  }

  initData() {
    var currentUser = this.auth.getCurrentUser();
    this._currentData.currentUser = currentUser;
    this._currentData.firstTimeLogin = this.auth.currentUserValue ? this.auth.currentUserValue.pwd_reset_first_time_login:false;
    this._currentData.organizations = [];
    this._currentData.org = {};
    this._currentData.orgId = false;

    this._currentData.roleList = [];
    this._currentData.currentRole = {};
    this._currentData.locationList = [];
    this._currentData.loggedInUserName = (currentUser && currentUser.first_name != undefined) ? currentUser.first_name : 'User';
    var regex = /(Mr|MR|Ms|Miss|Mrs|Dr|Sir)(\.?)\s/;
    this._currentData.loggedInInitial = (this.appService._currentSessionData.name != undefined) ? this.appService._currentSessionData.name.replace(regex, '').split(" ")[0][0] + "" + (this.appService._currentSessionData.name.replace(regex, '').split(" ")[1] ? this.appService._currentSessionData.name.replace(regex, '').split(" ")[1][0] : '') : "U";
    this._currentData.colorCoding = (this.appService._currentSessionData.name != undefined) ? this.utilService.colorCoding(this.appService._currentSessionData.name.replace(regex, '').split(" ")[0][0]) : "#000000";
  }

  getRoles() {
    if (this.appService._currentSessionData.roleList && this.appService._currentSessionData.roleList.length > 0) {
      this._currentData.roleList = this.appService._currentSessionData.roleList;
      if (this.appService.getRoles()) { 
        this._currentData.currentRole = this.appService.getRoles();
      } else {
        this._currentData.currentRole = this._currentData.roleList[0];
      }
      this.appService.setRole(this._currentData.currentRole);
      //this.sessionStoringForRole(this._currentData.currentRole);
    }
  }

  getOrganization() {
    if (this.appService.getOrganizationList() && this.appService.getOrganizationList().length > 0) {
      this._currentData.organizations = this.appService.getOrganizationList();
      this.facilitySearchSelect.datasource.possible_value = this.appService.getOrganizationList();
      if (this.appService.getOrganization()) {
        let currentOrg = this.appService.getOrganization();
        this._currentData.orgId = currentOrg.org_id;
        // This is written so that if changed in master it should reflect on hard refresh
        this._currentData.org = this._currentData.organizations.find(val => {
          return val.org_id == this._currentData.orgId;
        });
      } else {
        this._currentData.orgId = this._currentData.organizations[0].org_id;
        this._currentData.org = this.search(this._currentData.orgId, this._currentData.organizations, 'org_id');
      }
      var obj = {};
      obj[this.appService._appData.ORG_KEY] = this._currentData.orgId;
      this.appService.setOrganization(this._currentData.org);
    }
  }


  getLocation() {
    if (this.appService.getCurrentLocation()) { } else {
      let loc_obj = this.appService.getLocation();
      if (loc_obj && loc_obj.length > 0 && this.appService.isLocationAware()) {
        // this.appService.setCurrentLocation(loc_obj[0]);
        this.sessionStoringForLocation(loc_obj[0], false, false);
      }
    }
  }
  onItemSelect(event: any) {
    this.appService.removeOrganization();
    this.appService.removeCurrentRole();
    let org = this.search(event.id, this.appService.getOrganizationList(), 'org_id');
    let obj = {};
    obj[this.appService._appData.ORG_KEY] = event.id;
    this.sessionStoringForOrganization(obj, org);
  }

  search(nameKey, myArray, searchKey) {
    let obj = myArray.find(o => o[searchKey] === nameKey);
    return obj;
  }

  checkSystemAdmin() {
    if (this.auth.getCurrentUser() != null && this.auth.getCurrentUser().role_type && this.auth.getCurrentUser().role_type.toLowerCase() == 'systemadmin') {
      return false
    } else {
      return true
    }
  }

  sessionStoringForRole(obj, refresh = true) {
    if (obj.user_type.toLowerCase() == 'patient' && !obj.is_patient && obj.uhid == undefined) {
      this.subscriptions.add(this.baseService.getById(this._currentData.currentUser['user_id'], 'account_user', 'account-management').subscribe(
        res => {
          if (res) {
            console.log(res);
            res.telecom = res.contact_no;
            res.name_ = {
              "text": res.first_name,
              "given": res.middle_name,
              "family": res.last_name
            };
            res.emailAddress = res.email_address;
            this.baseService.setContextForPatient(true);
            let object = {
              "layout_type": "simple",
              "resource": "patient",
              "action": "add",
              "application": "patient-registration",
              "data": res
            }

            this.subscriptions.add(this.modalService.open(PopupFormComponent, object, "Add Details", ModalSize.Lg, 'center', true).subscribe(
              response => {
                console.log("Response is ", response);
                if (response && response.result && response.result.errCode == 0 && response.result.resource && response.result.resource.length > 0) {
                  this.dialogRef.close();
                  obj.uhid = response.result.resource[0].uhId;
                  obj.is_patient = true;
                  this.roleStorage(obj, refresh);
                }
              }));
          }
        }));
    } else {
      this.roleStorage(obj, refresh);
    }

  }

  roleStorage(obj, refresh = true) {
    this.subscriptions.add(this.baseService.add({ role: obj.role }, 'change_role_event', true, this.appService._appData.DEFAULT_APPLICATION).subscribe(
      (data: any) => {
        if (data.errCode == -1) {
          this.alertService.error('Not able to set role');
        } else {
          if (data.resource != undefined && data.resource.length) {
            if (obj.user_type.toLowerCase() == 'patient' && obj.is_patient && obj.uhid != undefined) {
              this.storageService.getData('currentUser', (res) => {
                res.user_type = obj.user_type;
                this.auth.setUser(res);
                this.storageService.setData('LoggedInUser', res, () => {
                  console.log('Logged In User Saved');
                });
                this.storageService.setData("hasUhId", obj.uhid, () => {
                  console.log("uhid data saved alredy")
                })
              });
            } else {
              this.storageService.getData('currentUser', (res) => {
                res.user_type = obj.user_type;
                res.role = data.resource[0].role;
                res.role_type = data.resource[0].role_type;
                this.auth.setUser(res);
                this.storageService.setData('currentUser', res, () => {
                  console.log('Logged In User Saved');
                });
              });
              if (localStorage && localStorage.getItem("LoggedInUser") != null) {
                localStorage.removeItem("LoggedInUser");
                localStorage.removeItem("hasUhId");
              }
            }
            this.setParticularRole(data.resource[0]);
            this.appService.deleteLocation(); // For removing locationId from session
            this.appService.removeOrganization(); //For remove organization array from storage
            if (refresh) {
              this.storageService.reloadOtherTab();
            }
            var super_app_url = this.auth.getCurrentUser().super_app_url;
            console.log("super_app_url -->", super_app_url);
            if (super_app_url == undefined) {
              super_app_url = "/";
            }
            window.location.href = window.location.origin + super_app_url; // refresh window when role changed
          } else {
            this.alertService.error(data.message);
          }
        }
      }, error => {
        console.log(error);
        this.alertService.error('API error');
      }));
  }

  setParticularRole(dt) {
    let arr = ["role", "role_group_scope", "facility_id", "user_type", "role_type"]
    let rl: any
    arr.forEach(x => {
      if (dt.x)
        rl.x = dt.x;
    });
    this.appService.setRole(rl);
  }

  sessionStoringForOrganization(obj, org, refresh = true) {
    obj.time_zone = org.time_zone;
    //account aware changes
    if (this.appService.isFacilityAware()) {
      this.appService.setOrganization(org);
      this.communicationService.emitChange({ org: org });
      window.location.reload()
    } else {
      this.appService.deleteLocation();
      // if (!this.appService.isFacilityAware)
      this.subscriptions.add(this.baseService.add(obj, 'change_facility_event', true, this.appService._appData.DEFAULT_APPLICATION).subscribe(
        (data: any) => {
          if (data.errCode == -1) {
            this.alertService.error('Not able to set Organization Id');
          } else {
            if (data.resource != undefined && data.resource.length) {
              this.appService.setOrganization(org);
              this.communicationService.emitChange({ org: org });
              if (data.resource[0].location != undefined && data.resource[0].location.length) {
                this.appService.setLocation(data.resource[0].location);
              } else {

              }
              if (refresh) {
                this.storageService.reloadOtherTab();
              }
              var super_app_url = this.auth.getCurrentUser().super_app_url;
              console.log("super_app_url -->", super_app_url);
              if (super_app_url == undefined) {
                super_app_url = "/";
              }
              window.location.href = window.location.origin + super_app_url; // refresh window when role changed
            } else {
              this.alertService.error(data.message);
            }
          }
        }, error => {
          console.log(error);
          this.alertService.error('API error');
        }
      ));
    }
  }
  sessionStoringForLocation(location, unset, refresh = true) {
    let obj = { 'location_id': location.location_id, 'unset': unset };
    this.subscriptions.add(this.baseService.add(obj, 'change_location_event', true, this.appService._appData.DEFAULT_APPLICATION).subscribe(
      (data: any) => {
        if (data.errCode == 0 && data.resource.length > 0) {
          if (!unset) { // For setting location Id
            this.appService.setCurrentLocation(location);
          } else { // // For removing location Id
            this.appService.deleteLocation();
          }
          if (refresh) {
            this.storageService.reloadOtherTab();
            window.location.reload();
          }
        }
      }));
    // this.storageService.getData('CURRENT_LOCATION',(res) =>{
    //   if(res){
    //       if(res.location_id == location.id){}else{
    //         this.setLocationData(location, unset, refresh = true)
    //       }
    //   }else{
    //       this.setLocationData(location, unset, refresh = true)
    //   }
    // })
  }

  languageChange(value) {
    this.translateService.setLanguage(value, () => {
      window.location.reload();
    });
  }

  OrganizationChange(organization) {
    this.appService.removeOrganization();
    let org = this.search(organization, this.appService.getOrganizationList(), 'org_id');
    let obj = {};
    obj[this.appService._appData.ORG_KEY] = organization;
    this.sessionStoringForOrganization(obj, org);
  }

  toggleMinimize(e) {
    this.minimized = e;
  }

  showById(id) {
    if (document.getElementById(id))
      document.getElementById(id).classList.toggle("show");
  }
  closeDropdownEvents() {
    if (this.config.showFacility) {
      this.config.showFacility = false;
    }
    if (this.config.showRole) {
      this.config.showRole = false;
    }
    if(this.config.showFamilyMember){
      this.config.showFamilyMember = false;
    }
    if (this.config.showSuperAppMenu) {
      this.config.showSuperAppMenu = false;
    }
    if (this.config.showLocation) {
      this.config.showLocation = false;
    }
    if (this.showNotification) {
      this.showNotification = false;
    }
    if (this.config.showProfile && !this.utilService.isMobile()) {
      this.config.showProfile = false;
    }
    //for tablet landscape mode
    if (this.config != undefined && this.config.showProfile && this.utilService.isTalbet() && (this.utilService.getWidth() > this.utilService.getHeight())) {
      this.config.showProfile = false;
    }

    this.config.helpdeskTicket = false;
    this.cdr.detectChanges();
  }
  logout() {
    this.loaderService.showSpinner();
    // if (this.storageService.getLocalStorageDataSync("userDeskList") && this.appService.getAccountConfigValue("stop_desk_on_logout") && this.appService.getAccountConfigValue("stop_desk_on_logout") == "stop_desk_on_logout") {
    //   this.removedActiveDesk(this.storageService.getLocalStorageDataSync("userDeskList"))
    // }
    this.subscriptions.add(this.baseService.action({ notification_id: localStorage.getItem("notificationId") }, "", this.appService._appData.DEFAULT_APPLICATION, "logout").subscribe(
      (data: any) => {
        if (data.errCode == -1) {
          this.alertService.error(data.message);
        } else {
          this.storageService.reloadOtherTab();
          this.logoutSuccess();
        }
        this.loaderService.hideSpinner();
      }, error => {
        this.loaderService.hideSpinner();
        this.alertService.error('API error');
      }
    ));
  }

  showSuperApp(){
    return (this.superApps && this.superApps.length>0 && this.auth.getUserType() != 'patient')
  }

  logoutSuccess() {
    if (this.timeSub) {
      this.timeSub.unsubscribe();
    }
    var isADLogin = this.adService.isADLogin();
    var adType = localStorage.getItem("ad_type");
    this.auth.logout(() => {
      if (this.appService._initialRouteConfig) {
        this.router.resetConfig(this.appService._initialRouteConfig);
      }
      if (this.appService._appData.SUPER_APP != undefined) {
        let url = window.location.origin + "/" + this.appService._appData.DEFAULT_APPLICATION + "/login";
        console.log("login url --> ", url);

        if(isADLogin){
          this.adService.adLogout(adType,isADLogin);
        }else{
          this.baseService.redirect(url, "_self").then(() => {
            // window.location.reload();
          });
        }
        
      } else {
        if(isADLogin){
          this.adService.adLogout(adType,isADLogin);
        }else{
          this.baseService.redirectToLogin();
        }
        
      }
    });
  }
  public getNotification(count: any, clickData: any) {
    if (count == 1) {
      this.payload = []
    }
    this.subscriptions.add(this.messagingService.getNotification$((this.scrollPage / 10) - 1).subscribe((hasNotification) => {
      let _notification = hasNotification.resource
      if (hasNotification.resource != undefined) {
        this.totalCount = hasNotification.resource.length;
        this.getNotificationCount();
        for (let i = 0; i < _notification.length; i++) {
          let _khaliObj = {}
          if (_notification[i].payload != "") {
            _khaliObj['payload'] = JSON.parse(_notification[i].payload);
            _khaliObj['g_creation_time'] = _notification[i].g_creation_time
          } else {
            _khaliObj['payload'] = _notification[i].payload;
            _khaliObj['g_creation_time'] = _notification[i].g_creation_time
          }
          this.payload.push(_khaliObj);
        }
      }
    }));
    if (clickData) {
      this.scrollPage = 10;
      return this.showNotification = !this.showNotification;
    }
    this.messagingService.setcolorData(false)
    this.cdr.detectChanges();
  }

  onScrollList(event: any) {
    console.log("event is :: ", event)
    if (event == 100) {
      if (this.count >= 0) {
        this.scrollPage = (this.scrollPage) + 10
        this.getNotification(2, false)
      }
    }
  }

  setLatLng() {
    let currentLatitude;
    let currentLongitude;
    let ambulanceNo;
    let poly;
    let polylineLat = [];
    if (this.appService.getRoles() != null && this.appService.getRoles().role != undefined && this.appService.getRoles().role == "Paramedic Nurse") {//TODO: it should not be hardcoded
      this.baseService.getloadScript$();
      this.timeSub = timer(0, 15000).subscribe(() => {
        if (this.auth.getCurrentUser()['user_id']) {
          this.subscriptions.add(this.baseService.get('GET_DETAILS_BY_PARAMEDIC', 'paramedic_id:' + this.auth.getCurrentUser()['user_id'], 'ambulance_staff_mapping', 'ambulance-management').subscribe(data => {
            if (data.resource[0]) {
              ambulanceNo = data.resource[0].ambulance_vehicle_number;
              poly = data.resource[0].polyline;
              navigator.geolocation.getCurrentPosition((position) => {
                let obj = { ambulance_vehicle_number: ambulanceNo, latitude: position.coords.latitude, longitude: position.coords.longitude, deviated: false }
                if (position && ambulanceNo && poly) {
                  currentLatitude = position.coords.latitude;
                  currentLongitude = position.coords.longitude;
                  let myPosition = new google.maps.LatLng(currentLatitude, currentLongitude);
                  var s = polyline.decode(poly)
                  for (let i = 0; i < s.length; i++) {
                    var Obj = {}
                    Obj['lat'] = s[i][0];
                    Obj['lng'] = s[i][1];
                    polylineLat.push(Obj);
                  }
                  var ambulancePath = new google.maps.Polyline({
                    path: polylineLat,
                    geodesic: true,
                  });
                  if (google.maps.geometry.poly.isLocationOnEdge(myPosition, ambulancePath, 10e-4)) {
                    obj['deviated'] = false
                    console.log('within range')
                  }
                  else {
                    obj['deviated'] = true
                  }
                }
                else {
                  if (position && ambulanceNo) {
                    obj['deviated'] = true
                  }
                }
                this.subscriptions.add(this.baseService.action(obj, 'update_location', 'ambulance-management', 'ambulance_approve').subscribe(res => {
                  console.log("update response is", res);
                }));
              })
            }
          }));
        }
      });
    }
  }

  public changeopdType(event: any) {
    this.preferenceService.changeopdType(event, (res) => {
      if (res) {
        this.storageService.reloadOtherTab()
        window.location.reload()
      } else {
        this.storageService.reloadOtherTab()
        window.location.reload()
      }
    })
  }

  _getmultiOpdConfig(config: any) {
    if (Array.isArray(this.preferenceService.config.allowedCareType) && this.preferenceService.config.allowedCareType.length) {
      return this.preferenceService.config.allowedCareType;
    }
    return this.appService.getUniversalConfig(config)
    // return true
  }

  getProfilePath() {
    if (this.appService._currentSessionData.profile_path == undefined) {
      var profilePath = 'dms/api/v1/userImage/image-response-entity?args=id:' + this.appService._currentSessionData['profile_id'];
      this.subscriptions.add(this.baseService.getFileByUrl(profilePath).subscribe((data) => {
        this.appService._currentSessionData.profile_path = data;
        this.profile_path = this.appService._currentSessionData.profile_path;
      }));
    } else {
      this.profile_path = this.appService._currentSessionData.profile_path;
    }

  }


  public getNotificationCount() {
    this.subscriptions.add(this.messagingService.getNotificationCount$().subscribe((res: any) => {
      this.count = res.count;
    }));
  }

  selectProfile() {
    this.subscriptions.add(this.modalService.open(SelectProfileComponent, '', 'Manage Your Profiles', ModalSize.Sm, 'center', true).subscribe(res => {
    }));
  }

  checkConsent() {
    this.subscriptions.add(this.modalService.open(ConsentCheckComponent, '', 'Consent Check', ModalSize.Sm, 'center', true).subscribe(res => {
    }));
  }

  setPrimary(data) {
    // let obj = {
    //   data: data,
    //   patient: true
    // }
    // this.subscriptions.add(this.modalService.open(LoginMobileNoComponent, obj, 'Set Primary', ModalSize.Sm, 'center', true).subscribe((res: any) => {
    //   console.log("res is :: ", res)
    // }));
  }

  changePass() {
    let user = this.auth.getCurrentUser();
    if (user) {
      this.router.navigate(['/changepass']);
    } else {
      this.router.navigate(['/login']);
    }
  }

  setDefaultFacility() {
    var data = {
      "data": { "organization_id": this.appService.getOrganizationList()[0].org_id },
      "layout_type": "simple",
      "resource": "default_facility",
      "action": "MODIFY"
    }

    this.subscriptions.add(this.modalService.open(PopupFormComponent, data, '', ModalSize.Sm).subscribe(
      (res) => {
        // this.patientDetail.uhId = res.result.resource[0].uhId
        // if (res.result.errCode == 0) {
        //   this.createBill();
        // }
      },
      err => {
        console.error("Error in getting data : ", err)
      }
    ));
  }



  changeLandingUrl() {
    let user = this.auth.getCurrentUser();
    if (user) {
      this.router.navigate(['/landing_url']);
    } else {
      this.router.navigate(['/login']);
    }
  }

  // viewTrainingVideos() {
  //   let user = this.auth.getCurrentUser();
  //   if (user) {
  //     this.router.navigate(['/view_training_videos']);
  //   } else {
  //     this.router.navigate(['/login']);
  //   }
  // }

  locationChange(location) {
    this.sessionStoringForLocation(location, false);
  }

  removeLocation() {
    this.sessionStoringForLocation(location, true);
  }

  profileDetails() {
    let userId = this.auth.getCurrentUser()['user_id'];
    if (this._currentData.currentRole && this._currentData.currentRole.role_type == 'Practitioner') {
      this.router.navigate(['facility-management/doctor_profile_view', userId, 'doctor-profile']);
    } else {
      this.router.navigate(['patient-registration/patient_profile', userId, 'patient-profile'])
    }
  }

  checkUserType() {
    if (this.auth.getUserType() == 'patient' || (this._currentData.currentRole && this._currentData.currentRole.role_type == 'Practitioner'))
      return true
    else
      return false

  }

  checkKioskUser(){
    return this.appService != undefined && this.appService._iskiosk
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
    if (this.speedConfig.sub != undefined) {
      this.speedConfig.sub.unsubscribe();
    }
    if (this.config.headerConfigSub != undefined) {
      this.config.headerConfigSub.unsubscribe();
    }
    if (this.routerSubscription != undefined) {
      this.routerSubscription.unsubscribe();
    }
  }

  checktelemedicine() {
    if (this.baseService.getTeleService() != undefined && this.baseService.getTeleService().currentCall.minimized && this.utilService.isMobile()) {
      return "app-telemedicine-minimized"
    } else {
      return ""
    }
  }

  checkPagination() {
    if (document.getElementById("grid-mobile-pagination")) {
      return true;
    } else {
      return false;
    }
  }

  openEula(eula) {
    this.subscriptions.add(this.modalService.open(EulaComponent, eula, '', ModalSize.Lg, 'center', true).subscribe(res => {
      if (res) {
        console.log('tnc modal closed');
      }
    }, err => {
      console.error('error occured in tnc modal', err);
    }));
  }

  openSpeedTest() {
    this.subscriptions.add(this.modalService.open(SpeedTestComponent, {}, '', ModalSize.Md, 'center', true).subscribe(res => {
      if (res) {
        console.log('speedtest modal closed');
      }
    }, err => {
      console.error('error occured in speedtest modal', err);
    }));
  }

  openShortcuts() {
    this.subscriptions.add(this.modalService.open(ScreenShortcutsComponent, {}, 'Screen Shortcuts', ModalSize.Md, 'center', true).subscribe(res => {
      if (res) {
        console.log('shortcut modal closed');
      }
    }, err => {
      console.error('error occured in speedtest modal', err);
    }));
  }

  configureHeader() {
    var obj: any = {};
    obj["resource_name"] = "main_header";
    obj["context"] = "header";
    obj["key"] = "account__" + obj["resource_name"];
    this.preferenceService.openPopUp(obj, { headerItems: {} }, (response) => {
      if (response.result != undefined) {
        this.preferenceService.saveConfigurationData(obj, response.result, (result) => {
          console.log(result);
        });
      }
    });
  }

  showQRScanner(){
    this.router.navigateByUrl("/account-management/qr_scan");
  }
  configureMenu() {
    var obj: any = {};
    obj["resource_name"] = "main_menu";
    obj["context"] = "menu";
    obj["key"] = "account__" + obj["resource_name"];
    this.preferenceService.openPopUp(obj, { navItems: this.appService._currentSessionData.origMenuList }, (response) => {
      if (response.result != undefined) {
        this.preferenceService.saveConfigurationData(obj, response.result, (result) => {
          console.log(result);
        });
      }
    });
  }

  join(data: any) {
    this.baseService.getTeleService().joinChannel(data)
  }

  toggler(e) {
    if (document.body.classList.contains('sidebar-show') && this.appService.showSidebar) {
      // this.classToggler.removeClassesCustom(sidebarCssClasses);
      const cssClass = `sidebar-show`;
      // this.classToggler.toggleClasses(cssClass, sidebarCssClasses);
      document.body.classList.toggle(cssClass)
      this.appService.showSidebar = false;
      // this.cdr.detectChanges()
    }
  }
  installApp() {
    var installRes = this.utilService.isInstallable(pwaPrompt);
    if (installRes) {
      if (installRes != 1) {
        const config: ModalOptions = {
          backdrop: true,
          keyboard: false,
          animated: true,
          initialState: {
            data: installRes
          }
        };
        this.bsModalService.show(AppAlertComponent, config);
      } else {
        pwaPrompt.prompt();
      }
    }
  }

  isInstallable() {
    return (this.utilService.isInstallable(pwaPrompt) != 0);
  }
  ngAfterViewInit() {
    this.showInstallBtn = this.isInstallable();

  }

  getCurrentYear() {
    return new Date().getFullYear()
  }

  public onFilter(event) {
    if (this.config && this.config.headerComponent) {
      var valid = this.filterValidate(event);
      if (valid) {
        console.log("Key " + event.key);
      }
    }
  }

  public filterValidate(e) {
    var invalidChars = ["%=+-_()*&^$#@!`~.<>/\\';:[]]{}|"];
    if (invalidChars.includes(e.key)) {
      e.preventDefault();
      return false;
    } else {
      return true;
    }
  }

  onSearchKey(event) {
    console.log("Value is =>", event.target.value);
    this._currentData.roleList = this.appService._currentSessionData.roleList.filter(x => x.role.toLowerCase().includes(this['filterKey'].toLowerCase()));
    if (this['filterKey'] != "" && this._currentData.roleList.length != undefined) {
      // this._currentData.roleList 
    } else {
      this._currentData.roleList = this.appService._currentSessionData.roleList;
    }
  }

  handleKeyEnter(event) {
    event.preventDefault();
  }

  checkShowRole(e) {
    // console.log(e);
    // console.log(this.config.showRole);
    (e.target.id == "complex-search-input") ? this.config.showRole = true : false;
  }

  showFamilyMember(e){
    if(this.utilService.isMobile()){
      this.selectProfile();
      return;
    }
    return this.config.showFamilyMember = !this.config.showFamilyMember;
  }

  // removedActiveDesk(deskList) {
  //   // const storedDesks = this.storageService.getSessionStorageDataSync("DeskList");
  //   // if (!storedDesks) return;
  //   // const deskArray = typeof storedDesks === 'string' ? JSON.parse(storedDesks || '[]') : Array.isArray(storedDesks) ? storedDesks : [];
  //   // const startDesk = deskArray.map(d => d.deskId).join('#');
  //   // if (startDesk) {
  //     // const data = { desk_list: startDesk };
  //     // console.log('Payload JSON:', JSON.stringify(data));
  //     this.baseService.action({desk_list: deskList}, "BULK_DESKS_STOP", "queue-management", "queue_desk").subscribe(event => console.log('Desks stopped successfully', event));
  //   // }
  // }

  getlocationText(res) {
    this.translateService.translate(res).subscribe(x => {
      if (x) {
        res = x;
      }
    });
    return res;
  }
  tooglAccessibility(){
    //UserWay.widgetToggle();
    const asideContainer = document.getElementById('aside-modal-container');
    const isPanelVisible = !!asideContainer && !asideContainer.classList.contains('d-none');

    if (isPanelVisible) {
      this.asideBarService.removeComponent();
      return;
    }
     let componentConfig = {
            inputs: {
                data: {},
                hide_expand_btn: true
            }
        };
         let title = `Accessibility Menu (Ctrl+U)`;
         this.asideBarService.appendComponentTo('aside-modal-container', AccessibilityComponent, componentConfig, "overlay", title).subscribe(data => {
                if (data) {
                    //TODO
                }
      });
  }

  openHelpDocument() {
    const url = this.router.url;
    if (url != undefined) {
      const modalSub = this.modalService.open(HtmlViewerComponent, { data: { help_document_url: url } }).subscribe(
        response => {
          modalSub.unsubscribe();
        }
      )
    } else {
        console.error("resource not found for help");
        this.alertService.error("hpnf")
    }
  }

  openWebsite() {    
    const website = this.appService._currentSessionData["accountWebsite"];
    if (!website) return;
    this.utilService.openWebsite(website,this._currentData.currentUser['user_id']);      
  }
  
  naviagteToLink(path) {
    if (path) {
      this.router.navigate([path]);
    }
  }

}

export class FacilitySearchSelectModel {
  datasource = {
    "possible_value": []
  };
  defaultsetting = {
    "singleSelection": true,
    "checkBoxRequired": false,
    "closeDropDownOnSelection": true,
    "hasAppliedCss": true,
    "advancesearch": false,
    "location_icon": "fa fa-map-marker ml-1 pr-1"
  };
  question = new SearchAndSelect({
    defaultsetting: this.defaultsetting,
    getterKey: 'org_id',
    getterValue: 'org_name',
    options: false,
    type: "String",
    // template: "<div class='u-search-items position-relative border-bottom pl-2 pr-2 pb-1 pt-1'><div class='top-search-result'>!!!org_name!!!</div><div>!!!org_name!!!</div></div>",
    format: '(function (item) {return "".concat(item.org_name, ", ").concat(item.primary_address.cityDisplayName != undefined ? item.primary_address.cityDisplayName : "", ", ").concat(item.primary_address.stateDisplayName != undefined ? item.primary_address.stateDisplayName : "");})'
  });
}
